/**
 * @param {string} firstName
 * @param {string} lastName
 * @return {string} initials
 */
export default function getInitials(firstName, lastName) {
  if (typeof firstName !== 'string' || typeof lastName !== 'string') {
    return false;
  }

  return `${firstName[0]}${lastName[0]}`;
}